import { productImageResolution, productImageSizes } from '../constants';
/**
 * This function return the resolution index.
 *
 * @param res - The response which is a part of url.
 * @param call - The call which is a part of url.
 * @returns - Return the index.
 */
const findResolutionIndex = (res, call) => {
    for (let i = 0; i < productImageSizes.length; i += 1) {
        const size = productImageSizes[i];
        const [currentRes, currentCall] = productImageResolution[size];
        if (currentRes === res && currentCall === call) {
            return i;
        }
    }
    return undefined;
};
export default findResolutionIndex;
//# sourceMappingURL=findResolutionIndex.js.map